<div style="min-height: calc(100vh - 100px);">
  <div class="navbar__group">
    <div class="container">
      <nav class="navbar navbar-toggleable-md navbar-inverse">
        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbar"
          aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span> </span>
          <span> </span>
          <span> </span>
        </button>
        <!-- <a class="navbar-brand">
          <img src="./assets/images/home/logo.svg" alt="">
        </a> -->

        <div class="collapse navbar-collapse" id="navbar">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="Constant.url_partner_dashboard_page">
                Partner
                <span></span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="Constant.url_license_dashboard_page">
                License
                <span></span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="Constant.url_supervisor_dashboard_page">
                Giám sát
                <span></span>
              </a>
            </li>
          </ul>
        </div>
        <a (click)="logout()" class="btn-lightblue-r8">Đăng xuất</a>
        
      </nav>
    </div>
  </div>
  <div class="page-container">
    <div class="main-content">
      <router-outlet></router-outlet>
      <router-outlet name="popup"></router-outlet>
    </div>
  </div>
</div>
<app-footer></app-footer>
